var resources = require('items-view-strings');
    var strings = resources['_/pMikQ6zSI/XJAQ4P2zQMQ'];
export { strings };
export default strings;
